import CustomChip from '../../../../../components/CustomChip';
import { CustomDateRangePicker } from '../../../../../components/CustomDateRangePicker';
import CustomGenericTittleIconDataChip from '../../../../../components/CustomGenericTittleIconDataChip';
import DisplayView from '../../../../../components/DisplayView';
import { colors } from '../../../../../enums/colors';
import {IconMapButton} from "../../../../../components/buttons/IconButtons";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DetailsHeader = (props) => {
    const { dateRange, setDateRange, view, setView, t, finesCount } = props;
    return (
        <>
            <div className='col-12 col-md-8 d-flex align-items-center m-0 p-0'>
                <div className='me-2'>
                    <DisplayView useMap={true} view={view} iconRight={IconMapButton} setView={setView} />
                </div>

                <div className='me-2 mt-3 flex-grow-1 w-100'>
                    <CustomDateRangePicker
                        id='dp_dh_date_range'
                        name='dateRange'
                        disabled={false}
                        trans='date_range'
                        value={dateRange}
                        setRangeDate={setDateRange}
                        required={true}
                        maxDate ={new Date()}
                    />
                </div>

                <div className='vertical-separator-shades-950 h-36px mt-4 mb-4' />
                <div className='mt-2'>
                    <CustomGenericTittleIconDataChip
                        title={t('total_fines')}
                        badge={
                            <CustomChip
                                background={colors.shades200}
                                fontColor={colors.shades500}
                                borderColor={colors.shades300}
                                legend={finesCount}
                                variant='compact'
                            />
                        }
                        border={false}
                    />
                </div>
            </div>
        </>
    );
};

export default DetailsHeader;
